import script from "./FleetPressureBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./FleetPressureBoard.vue?vue&type=script&setup=true&lang=js"

import "./FleetPressureBoard.vue?vue&type=style&index=0&id=9d4b4646&lang=scss"

const __exports__ = script;

export default __exports__